let module = angular.module('app.resources');

module.factory('BoxCaster', ($resource) => {
  'ngInject';
  var BoxCaster = $resource(
    `${API_ROOT}/account/boxcasters/:id`,
    { id: '@id' },
    {
      update: {
        method: 'PUT',
      },
      postRPC: {
        method: 'POST',
        url: `${API_ROOT}/account/boxcasters/:id/rpcs/:rpcId`,
        params: { id: '@id', rpcId: '@rpcId' },
      },
      getRPC: {
        method: 'GET',
        url: `${API_ROOT}/account/boxcasters/:id/rpcs/:rpcId`,
        params: { id: '@id', rpcId: '@rpcId' },
      },
      deleteRPC: {
        method: 'DELETE',
        url: `${API_ROOT}/account/boxcasters/:id/rpcs/:rpcId`,
        params: { id: '@id', rpcId: '@rpcId' },
      },
      getRegistration: {
        method: 'GET',
        url: `${API_ROOT}/account/boxcaster/registration`,
      },
      postRegistration: {
        method: 'POST',
        url: `${API_ROOT}/account/boxcasters`,
      },
    }
  );

  BoxCaster.prototype.hasWifi = function () {
    return this.id.startsWith('o') || this.id.startsWith('p');
  };
  BoxCaster.prototype.isPro = function () {
    return this.id.startsWith('p');
  };

  return BoxCaster;
});

export default module;



// WEBPACK FOOTER //
// ./app/resources/boxcaster.js